import React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'src/registry/ui/Tooltip';

export default function OverflownTooltip({ text }: { text: string }) {
    const textRef = React.useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = React.useState(false);

    React.useEffect(() => {
        const el = textRef.current;
        if (el) {
            setIsOverflowing(el.scrollWidth > el.clientWidth);
        }
    }, [text]);

    const content = (
        <div ref={textRef} className={`truncate ${isOverflowing ? 'cursor-pointer' : ''}`}>
            {text}
        </div>
    );

    if (!isOverflowing) {
        return content;
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild>{content}</TooltipTrigger>
            <TooltipContent side="left" className="max-w-xs break-words whitespace-normal">
                {text}
            </TooltipContent>
        </Tooltip>
    );
}
